import { useMemo } from 'react';
import bbox from '@turf/bbox';
import GoogleMap from '../../components/google/maps/Map';
import { useGrowers } from '../../hooks/use-growers';
import { useLayers } from './use-layers';

export function Map(props) {
  const {
    aaid = '00000000-0000-0000-0000-000000000000',
    boundary,
    boundaryId,
    endsAt,
    getControls,
  } = props;
  const { layers } = useLayers();
  const { selectedId: growerId } = useGrowers();
  const bounds = useMemo(() => bbox(boundary), [boundary]);
  const filters = useMemo(
    () => ({ growerId: growerId || props.growerId, aaid, boundaryId, endsAt }),
    [growerId, aaid, boundaryId, endsAt, props.growerId],
  );

  return (
    <GoogleMap
      pkRemovalEnabled
      filters={filters}
      bounds={bounds}
      layers={layers}
      selectedFeatures={{ boundary: [aaid] }}
      getControls={getControls}
    />
  );
}
